import React, {Component} from 'react';
import {connect} from "react-redux";
import {hideModal} from "../../../actions/nodeEditorPanelActions";
import ContextPropertyTab from "./ContextPropertyTab";
import LimitSameValues from '../components/LimitSameValues';
import ContextUpdaterTab from "./ContextUpdaterTab";
import PropertiesToRetrieveTab from './PropertiesToRetrieveTab';
import RenameTotalResult from "../components/RenameTotalResult";
import PaginationTab from "./PaginationTab";
import PanelLayout from "../components/PanelLayout";

class OutputPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTab: "Settings",
        };
        this.changeTab = this.changeTab.bind(this);
    }

    changeTab(event) {
        this.setState({selectedTab: event.currentTarget.dataset.id});
    }

    render() {
        return (
            <>
                <PanelLayout headerTabs={<>
                    <span data-id="Settings" onClick={this.changeTab}
                          className={this.state.selectedTab === "Settings" ? "navigation-tab current" : "navigation-tab"}>Settings</span>
                    <span data-id="Context Properties" onClick={this.changeTab}
                          className={this.state.selectedTab === "Context Properties" ? "navigation-tab current" : "navigation-tab"}>Context Properties</span>
                    <span data-id="Context Updaters" onClick={this.changeTab}
                          className={this.state.selectedTab === "Context Updaters" ? "navigation-tab current" : "navigation-tab"}>Context Updaters</span>
                    <span data-id="Properties to Retrieve" onClick={this.changeTab}
                          className={this.state.selectedTab === "Properties to Retrieve" ? "navigation-tab current" : "navigation-tab"}>Properties to Retrieve</span>
                    <span data-id="Pagination" onClick={this.changeTab}
                          className={this.state.selectedTab === "Pagination" ? "navigation-tab current" : "navigation-tab"}>Pagination</span>
                </>}
                             customTabs
                >
                    <div
                        className={this.state.selectedTab === "Settings" ? "gui-editor-content active" : "gui-editor-content"}>
                        <LimitSameValues/>
                        <RenameTotalResult/>
                    </div>
                    <div
                        className={this.state.selectedTab === "Context Properties" ? "gui-editor-content active" : "gui-editor-content"}>
                        <ContextPropertyTab/>
                    </div>
                    <div
                        className={this.state.selectedTab === "Context Updaters" ? "gui-editor-content active" : "gui-editor-content"}>
                        <ContextUpdaterTab/>
                    </div>
                    <div
                        className={this.state.selectedTab === "Properties to Retrieve" ? "gui-editor-content active" : "gui-editor-content"}>
                        <PropertiesToRetrieveTab/>
                    </div>
                    <div
                        className={this.state.selectedTab === "Pagination" ? "gui-editor-content active" : "gui-editor-content"}>
                        <PaginationTab/>
                    </div>
                </PanelLayout>
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        content: state.modalInfo.content,
        node: state.modalInfo.node
    }
}

export default connect(mapStateToProps, {hideModal})(OutputPanel);